const DEFAULT_LANG = 'en'

const getI18nLink = (link: string, language: string) => {
  const normalizedLanguage = language.toLowerCase().replace('_', '-')

  return link.replace('{lang}', normalizedLanguage)
}

export const getSupportLink = (lang = DEFAULT_LANG) => getI18nLink('https://help.hotmart.com/{lang}', lang)

export const getTermsLink = (lang = DEFAULT_LANG) => getI18nLink('https://www.hotmart.com/legal/{lang}', lang)
